import React from 'react';
import { Package, User, Route, AlertTriangle } from 'lucide-react';
import { StatCard } from '../../../../../components/ui/StatCard';

/**
 * The four counters above the table.
 *
 * They deliberately measure the day's operation and not a pickup lifecycle: a
 * pickup only exists once the order was scanned at the CD, so there is no
 * "scheduled" or "cancelled" to count. What there is: how much moved, who moved
 * it, over how many routes, and how many labels never made it out of the
 * printer.
 *
 * Every number is computed by the backend over the whole filtered set, so they
 * stay honest while paging.
 *
 * @param {object} props
 * @param {{total: number, drivers: number, routes: number, failed: number}} props.summary
 */
export const PickupStats = ({ summary }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
    <StatCard
      title="Pickups"
      value={(summary.total || 0).toLocaleString('es-CL')}
      icon={Package}
      subtitle="Órdenes escaneadas en el rango"
    />
    <StatCard
      title="Conductores"
      value={(summary.drivers || 0).toLocaleString('es-CL')}
      icon={User}
      subtitle="Distintos en el rango"
    />
    <StatCard
      title="Rutas"
      value={(summary.routes || 0).toLocaleString('es-CL')}
      icon={Route}
      subtitle="Órdenes de ruta distintas"
    />
    <StatCard
      title="Etiquetas fallidas"
      value={(summary.failed || 0).toLocaleString('es-CL')}
      icon={AlertTriangle}
      trend={summary.failed > 0 ? 'down' : undefined}
      trendValue={summary.failed > 0 ? 'Requieren reimpresión' : undefined}
      subtitle={summary.failed > 0 ? undefined : 'Sin fallos de impresión'}
    />
  </div>
);
